var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00586 8.89161C4.00586 6.02276 6.35729 3.66667 9.29564 3.66667C10.7043 3.66667 12.0517 4.22145 13.0424 5.20332C14.0325 6.18459 14.5854 7.51166 14.5854 8.89161C14.5854 11.7605 12.234 14.1165 9.29564 14.1165C6.35729 14.1165 4.00586 11.7605 4.00586 8.89161ZM9.29564 1.66667C5.26961 1.66667 2.00586 4.90138 2.00586 8.89161C2.00586 12.8818 5.26961 16.1165 9.29564 16.1165C13.3217 16.1165 16.5854 12.8818 16.5854 8.89161C16.5854 6.97543 15.8174 5.13774 14.4503 3.7828C13.0832 2.42786 11.229 1.66667 9.29564 1.66667ZM16.4648 14.7119L18.6359 16.4303H18.6736C19.1128 16.8657 19.1128 17.5715 18.6736 18.0068C18.2344 18.4422 17.5222 18.4422 17.083 18.0068L15.2812 15.9821C15.1109 15.8138 15.0152 15.5853 15.0152 15.347C15.0152 15.1087 15.1109 14.8801 15.2812 14.7119C15.6097 14.392 16.1363 14.392 16.4648 14.7119Z",
    fill: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.be914b24c4a88612718ee8273cb80182.svg";
export { ForwardRef as ReactComponent };